import { Box } from "@mui/material";
import Breadcrumbs from "components/Breadcrumbs";
import { useLocation } from "react-router-dom";

function BreadcrumbHome() {
  const route = useLocation().pathname.split("/").slice(1);
  return (
    <Box sx={{ padding: "0.75rem", borderBottom: "1px solid #d6d6d6" }}>
      <Breadcrumbs
        icon="home"
        title={
          route?.length > 3 ? route[route.length - 2] : route[route.length - 1]
        }
        route={route?.length > 3 ? route.slice(0, route?.length - 1) : route}
        home={"/"}
      />
    </Box>
  );
}
export default BreadcrumbHome;
